var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78426 15.9406L16.8171 9.76863C17.372 9.28167 17.4028 8.4675 16.8859 7.95012L10.3347 1.39252C9.81783 0.875141 8.94901 0.850478 8.39413 1.33744L1.36131 7.50944C0.806432 7.9964 0.775627 8.81058 1.2925 9.32796L7.84369 15.8856C8.36056 16.4029 9.22939 16.4276 9.78426 15.9406Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48486 5.6562L10.5516 7.39142C10.9925 7.76165 11.0241 8.43174 10.6204 8.8512L8.72809 10.8171",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.621d2a817d343073ebcf094cfc672453.svg";
export { ForwardRef as ReactComponent };